import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  template: `
    <a class="skip-link" href="#workspace">Skip to content</a>
    <div class="workspace-shell">
      <aside class="sidebar">
        <a class="brand" routerLink="/operations"
          ><span class="brand-mark" aria-hidden="true">m</span
          ><span>MicroKosm<strong>VOICE WORKSPACE</strong></span></a
        >
        <nav aria-label="Main navigation">
          <span class="nav-label">Workspace</span>
          <a routerLink="/operations" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">◫</span> Overview</a
          >
          <a routerLink="/campaigns" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">↗</span> Campaigns & agents</a
          >
          <a routerLink="/test-call" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">▷</span> Test studio</a
          >
          <a routerLink="/leads" routerLinkActive="active" ariaCurrentWhenActive="page"><span aria-hidden="true">◎</span> Leads & outcomes</a>
          <a routerLink="/call-history" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">≡</span> Calls & recordings</a
          >
          <span class="nav-label">Manage</span>
          <a routerLink="/costs" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">◷</span> Usage & costs</a
          >
          <a routerLink="/data-sources" routerLinkActive="active" ariaCurrentWhenActive="page"
            ><span aria-hidden="true">▤</span> Data sources</a
          >
          <a
            routerLink="/users"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            *ngIf="isAdmin()"
            ><span aria-hidden="true">◎</span> Team</a
          >
        </nav>
        <div class="sidebar-footer">
          <span class="avatar" aria-hidden="true">{{
            (auth.user()?.full_name || auth.user()?.email || 'U').charAt(0).toUpperCase()
          }}</span>
          <div>
            <strong>{{ auth.user()?.full_name || auth.user()?.email }}</strong
            ><small>{{ auth.user()?.role }}</small>
          </div>
        </div>
        <button class="logout" (click)="logout()">Sign out</button>
      </aside>
      <main id="workspace" tabindex="-1">
        <div class="workspace-topbar">
          <span>Voice workspace</span><a routerLink="/test-call">Open test studio ↗</a>
        </div>
        <div class="workspace-content"><router-outlet /></div>
      </main>
    </div>
  `,
  styles: [
    `
      .workspace-shell {
        display: grid;
        grid-template-columns: 232px minmax(0, 1fr);
        min-height: 100vh;
      }
      .sidebar {
        background: #101f2b;
        color: #d7e3ea;
        padding: 30px 18px 18px;
        display: flex;
        flex-direction: column;
        position: sticky;
        top: 0;
        height: 100dvh;
        box-sizing: border-box;
      }
      .brand {
        display: flex;
        gap: 12px;
        align-items: center;
        text-decoration: none;
        color: #fff;
        font-size: 19px;
        font-weight: 650;
        padding: 0 10px 32px;
      }
      .brand strong {
        display: block;
        font-size: 9px;
        letter-spacing: 1.8px;
        margin-top: 6px;
        color: #9eafb9;
      }
      .brand-mark {
        display: grid;
        place-items: center;
        width: 34px;
        height: 38px;
        border-radius: 10px;
        background: #b9efcf;
        color: #123e2b;
        font-size: 26px;
      }
      nav {
        display: grid;
        gap: 5px;
      }
      .nav-label {
        font-size: 10px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: #91a4b1;
        padding: 20px 12px 9px;
      }
      nav a {
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 12px;
        border-radius: 8px;
        color: #c4d0d8;
        text-decoration: none;
        font-size: 14px;
      }
      nav a span {
        width: 19px;
        font-size: 20px;
        line-height: 1;
      }
      nav a:hover {
        background: #20323e;
      }
      nav a.active {
        background: #264438;
        color: #d6ffe6;
        box-shadow: inset 3px 0 #a1e8ba;
      }
      .sidebar-footer {
        margin-top: auto;
        padding: 28px 8px 14px;
        display: flex;
        gap: 10px;
        align-items: center;
        min-width: 0;
      }
      .sidebar-footer div {
        min-width: 0;
      }
      .sidebar-footer strong {
        display: block;
        overflow-wrap: anywhere;
        font-size: 12px;
      }
      .sidebar-footer small {
        display: block;
        color: #9eafb9;
        margin-top: 4px;
        text-transform: capitalize;
      }
      .avatar {
        background: #304450;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: grid;
        place-items: center;
        flex-shrink: 0;
      }
      .logout {
        background: transparent;
        color: #c4d0d8;
        border: 1px solid #3b4e5a;
        border-radius: 7px;
        padding: 9px;
        cursor: pointer;
      }
      main {
        min-width: 0;
      }
      .workspace-topbar {
        height: 62px;
        border-bottom: 1px solid #e1e6e9;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 36px;
        font-size: 12px;
        color: #667784;
      }
      .workspace-topbar a {
        color: #226044;
        text-decoration: none;
        font-weight: 600;
      }
      .workspace-content {
        max-width: 1480px;
        margin: auto;
        padding: 32px 36px 64px;
      }
      .skip-link {
        position: fixed;
        top: -80px;
        left: 20px;
        background: white;
        padding: 14px;
        z-index: 100;
      }
      .skip-link:focus {
        top: 10px;
      }
      @media (max-width: 900px) {
        .workspace-shell {
          grid-template-columns: 1fr;
        }
        .sidebar {
          position: static;
          height: auto;
          padding: 16px;
        }
        .brand {
          padding: 0 8px 14px;
        }
        .sidebar nav {
          display: flex;
          overflow-x: auto;
          gap: 5px;
        }
        .nav-label,
        .sidebar-footer {
          display: none;
        }
        .logout {
          align-self: flex-end;
          margin-top: 10px;
          padding: 6px 14px;
        }
        nav a {
          white-space: nowrap;
          padding: 10px;
        }
        .workspace-content {
          padding: 22px 16px 40px;
        }
        .workspace-topbar {
          padding: 0 18px;
          height: 48px;
        }
      }
    `,
  ],
})
export class ShellPage implements OnInit {
  constructor(public readonly auth: AuthService) {}
  async ngOnInit(): Promise<void> {
    if (!this.auth.user()) await this.auth.loadMe();
  }
  isAdmin(): boolean {
    return this.auth.user()?.role === 'admin';
  }
  logout(): void {
    this.auth.logout();
    location.href = '/login';
  }
}
